

import CryptoJS from "crypto-js";
/* ---------- 签名算法 ---------- */
export const RSSign = (params, key) => {
    const aString = Object.keys(params)
        .filter(key => {
            return key !== "sign" && key !== "sign_type" && key !== "" && key !== null && params[key] !== undefined && params[key] !== "";
        })
        .sort()
        .reduce((prev, cur) => {
            return prev + `${cur}=${params[cur]}&`;
        }, "");
    return CryptoJS.MD5(`${aString}${key}`).toString();
};

/* ---------- RS MD5 加密---------- */
export const RSMD5 = (str) => {
    return CryptoJS.MD5(str).toString();
};
